import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Container, Grid, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { di } from '../../../state/inversify.config';
import { Resources } from '../../../components/resources/resources';
import { IncidentDisplayCard } from '../../../components/incidentCard/incidentDisplayCard.smart';
import { OpenIncidentsList } from '../../components/openIncidentsList/openIncidentsList.smart';
import { IncidentHeader } from '../../../components/incidentHeader/incidentHeader.smart';
import { AuthService } from '../../../state/helperServices/auth/auth.service';
import { getRouteByAccountType } from '../../../routes/getRouteByAccountType';
import { AddPlayerDomain } from '../../../pages/players/addPlayer.domain';
import { Button } from '../../../components/button/button';
import { PlayerCard } from '../../../components/playerCard/playerCard';

export const Home = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const addPlayerDomain = di.get<AddPlayerDomain>(AddPlayerDomain);
  const players = addPlayerDomain.usePlayersSelector();

  const authService = di.get(AuthService);
  const loggedInUser = authService.useLoggedInUserSelector();

  useEffect(() => {
    // TODO review this if needed sectionRef
    // const url = window.location.href;
    // const sectionId = url.substring(url.indexOf('#') + 1);
    // const sectionRef = document.getElementById(sectionId);
    // if (sectionRef) {
    //   sectionRef.scrollIntoView({ behavior: 'smooth' });
    // }
    window.scrollTo(0, 0);
  }, []);

  return (
    <Container>
      <Grid container sx={{ mb: 2 }}>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <IncidentHeader />
          <OpenIncidentsList />
          <IncidentDisplayCard accountType={loggedInUser?.accountType} />
          <Typography variant="h6" sx={{ my: 1 }}>
            {t('YOUR_FAMILY')}
          </Typography>
          <Grid container spacing={2}>
            {players.length <= 0 && (
              <Grid item xs={12}>
                <Button
                  type="submit"
                  variant="contained"
                  onClick={() =>
                    navigate(
                      `/${getRouteByAccountType(
                        loggedInUser?.accountType,
                      )}/players`,
                      { state: { addPlayerModal: true } },
                    )
                  }
                  startIcon={<AddIcon />}
                  sx={{ mb: 2 }}
                  label={t('ADD_PLAYER')}
                  color="secondary"
                />
              </Grid>
            )}
            {players.length > 0 ? (
              players
                .sort(
                  (a, b) => Number(a.clearedToPlay) - Number(b.clearedToPlay),
                )
                .map((playerItem) => {
                  return (
                    <Grid item xs={12} key={playerItem.id}>
                      <PlayerCard key={playerItem.id} player={playerItem} />
                    </Grid>
                  );
                })
            ) : (
              <Grid item>{t('NO_PLAYERS_IN_YOUR_FAMILY')}</Grid>
            )}
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={4} lg={4} sx={{ mb: 2, p: 2 }}>
          <section id="resources">
            <Resources />
          </section>
        </Grid>
      </Grid>
    </Container>
  );
};
